<template>
  <div style="height: 100%">
    <SplitContainer21 ref="refSplitContainer21" style="height:100%" :layout="12">
      <template #top>
        <TableMain name="one table" ref="QuotationTaskTable1" :fields="fields" :title="table_title.title1"
          :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
          :show_date_picker="false" :show_toolbar="true" :show_filter="true" :date_picker_label="date_picker_label"
          :query_button_label="query_lable" :isBusy="isBusy" :hb_table_class="'hb_table_qttable_class1'"
          @on_query="on_query" @state_change="state_change" :show_toolbar_button="[0, 0, 1, 1, 1]" :show_copy="true"
          :table_height_adjust="-6" @tool_invoke="tool_invoke" @current_changed="current_changed" :show_email="true"
          :email_label="'send_email'" :loading_width="90" @email_invoke="SendEmail"
          @on_cell_button_click="on_cell_button_click" tableref="133cb199b029469693be9b14c684fab8">
          <template #query>
            <el-date-picker class="ml-1" size="small" style="width: 220px" v-model="date_range" type="daterange"
              align="right" unlink-panels range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
              :picker-options="pickerOptions()">
            </el-date-picker>
            <el-input class="ml-1" clearable size="small" style="width: 180px" v-model="QuotationTaskNum"
              placeholder="报价申请编号"></el-input>
            <el-input class="ml-1" clearable size="small" style="width: 180px" v-model="CustName"
              placeholder="客户名称"></el-input>
          </template>
          <template #toolbar>
            <div style="display: inline-block">
              <el-button type="info" plain @click="createData" class="ml-2 iconfont icon-add-new" size="mini">
                {{ $t("common.new") }}
              </el-button>
              <el-checkbox-group style="display: inline-block" class="ml-2" v-model="checkedConditions"
                @change="only_methods_main">
                <el-checkbox v-for="(item, index) in onlyCheckOptions" :label="item.value" :key="index">{{ item.label
                  }}</el-checkbox>
              </el-checkbox-group>
            </div>
          </template>
        </TableMain>
      </template>
      <template #bottom>

        <TableMain ref="QuotationTaskTable3" :fields="detail_fields" :show_query_container="false"
          :title="table_title.title3" :date_picker_label="date_picker_label" :table_height_adjust="2"
          :show_pagination="true" :show_filter="false" :show_close="true" :hb_table_class="'hb_table_qttable_class2'"
          :pager_count="5" :isBusy="isBusy3" :loading_width="45" @state_change="detail_state_change"
          :show_toolbar_button="[0, 0, 0, 0, 1]" @on_input="detail_on_input" @on_change="detail_on_change"
          @on_cell_button_click="on_cell_button_click_detail" tableref="235798acc52a49a9ae2e29686ba652d1">
          <template #toolbar>
            <el-button type="info" plain @click="Detail_CopyData()" class="ml-2 iconfont icon-edit" size="mini">
              {{ $t("common.copy") }}
            </el-button>
            <el-button type="info" plain class="ml-2" @click="showInventView"><i
                class="iconfont icon-add-new"></i>&nbsp;&nbsp;选择物料
            </el-button>
            <el-button type="info" plain @click="Detail_CreateData()" class="ml-2 iconfont icon-add-new" size="mini">
              新增空行
            </el-button>
            <el-popover placement="right" title="提示" width="200" trigger="hover" content="如果没有物料则点击“新建”按钮进行添加。"
              style="border-color: red;">
              <i slot="reference" class="el-icon-question ml-2" style="font-size:18px;margin-top: 6px;"></i>
            </el-popover>
          </template>
          <template #operation>
            <QueryButton :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'" @on_query="Detail_SaveData"
              :label="$t('common.save')" class="ml-2"></QueryButton>
          </template>
        </TableMain>
      </template>
    </SplitContainer21>
    <!-- 报价申请 -->
    <BaseModal ref="QTModal" :title="qt_modal_title" @saveData="SaveData" :width="'35%'">
      <template #modal_content>
        <el-form :rules="rules" ref="dataForm" label-width="100px" class="demo-dataForm" style="height: 200px">
          <span v-for="(item, index) in QuotationTaskModel" :key="index">
            <el-col :span="24">
              <el-form-item :label="item.label" v-if="item.key == 'CustAccount'">
                <el-select size="small" v-model="item.value" filterable clearable :placeholder="`请选择${item.label}`"
                  class="w-100" :filter-method="filterMethod" @focus="filterMethod(item.value)"
                  @change="CustChanged(item.value)">
                  <el-option v-for="citem in cust_options" :key="citem.AccountNum"
                    :label="citem.AccountNum + ':' + citem.SEI_Name" :value="citem.AccountNum"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="item.label" v-if="item.key == 'dataAreaId'">
                <el-select size="small" v-model="item.value" filterable clearable :placeholder="`请选择${item.label}`"
                  class="w-100">
                  <el-option v-for="cm in $store.state.biz_data.baseData.CompanyInfo" :key="cm.DataArea"
                    :label="cm.DataArea + ':' + cm.CompanyName" :value="cm.DataArea"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="item.label" v-if="item.key == 'quotationType'">
                <el-select size="small" v-model="item.value" filterable clearable :placeholder="`请选择${item.label}`"
                  class="w-100">
                  <el-option label="大货报价" value="大货报价"></el-option>
                  <el-option label="打样报价" value="打样报价"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="item.label" v-else-if="item.key == 'ComplateDate'">
                <el-date-picker size="small" type="date" placeholder="选择申请完成时间" v-model="item.value"
                  style="width: 100%">
                </el-date-picker>
              </el-form-item>
              <el-form-item :label="item.label" v-else-if="item.key == 'Description'">
                <el-input type="textarea" v-model="item.value" clearable></el-input>
              </el-form-item>
            </el-col>
          </span>
        </el-form>
      </template>
    </BaseModal>
    <!-- 发送邮件 -->
    <el-dialog title="邮件通知" :visible.sync="emailVisible" width="80%" :top="'8vh'" :close-on-click-modal="false">
      <el-form ref="dataForm" label-width="60px" class="demo-dataForm" style="height: 650px">
        <el-col :span="24">
          <el-form-item label="主题">
            <el-input type="textarea" v-model="email_subject" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="内容">
            <div name="div_email_content" style="overflow:auto;height: 600px;border:1px solid #DCDFE6">
              <el-input type="textarea" ref="div_email_content" v-html="email_content" clearable></el-input>
            </div>
          </el-form-item>
        </el-col>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="sendToEmail" type="primary" plain><i class="iconfont icon-email"
            style="font-size: 12px"></i>&nbsp;发送邮件</el-button>
        <el-popover placement="right" title="提示" width="200" trigger="hover" content="点击“发送邮件”后内容已复制到剪切板，可直接粘贴使用！"
          style="border-color: red;">
          <i slot="reference" class="el-icon-question ml-2" style="font-size:18px;margin-top: 6px;"></i>
        </el-popover>
      </span>
    </el-dialog>
    <el-drawer :title="'选择物料'" :visible.sync="drawer" :with-header="true" :size="'70%'" @opened="DrawerOpend"
      style="height: calc(100vh)">
      <TableMain :table_height_default="tableHeight + 'px'" ref="QuotationTaskTable2" :show_query_container="false"
        :show_date_picker="false" :fields="inventTable_fields" :table_height_adjust="8" :title="table_title.title2"
        :date_picker_label="date_picker_label" :query_button_label="query_lable" :show_toolbar="false" :pager_count="5"
        :isBusy="isBusy2" :only_text1="$t('common.pub_invent')" @only_methods="only_methods"
        :hb_table_class="'hb_table_qttable_class3'" tableref="dc7c19c9d33746edb36a4cd29d116979">
        <template #operation>
          <el-button type="info" plain class="ml-2" @click="getInventIntoDetail"><i
              class="iconfont icon-save"></i>&nbsp;&nbsp;{{ $t("common.ok") }}
          </el-button>
        </template>
      </TableMain>
    </el-drawer>
    <!-- 进度展示 -->
    <el-dialog :title="`报价申请编号：${ProgressQuotationTaskNum}，行号：${ProgressQuotationTaskLineNum}`"
      :visible.sync="ProgressVisible" width="60%" :top="'12vh'" :close-on-click-modal="false">
      <el-timeline style="height: calc(60vh);overflow: auto; padding: 8px 16px;">
        <el-timeline-item size="large" v-for="(item, index) in ProgressData" :key="index" :hide-timestamp="true"
          placement="top" :type="item.progress_type">
          <el-card :body-style="{ padding: '12px' }">
            <h5>{{ item.progress_title }}</h5>
            <p>当前状态：{{ item.progress_status }}</p>
            <!-- <p>处理人：{{ item.progress_user }}</p> -->
          </el-card>
        </el-timeline-item>
      </el-timeline>
    </el-dialog>
  </div>
</template>

<script>
import * as InventTableController from "../../controllers/base/InventTableController"
import * as commonController from "../../controllers/commonController"
import * as QuotationTaskController from "../../controllers/sd/QuotationTaskController"
import * as SalesOrderController from "../../controllers/sd/SalesOrderController"
import BaseContainer from "../components/BaseContainer"
import QueryButton from "../components/base/QueryButton"
import SplitContainer21 from "../components/container/SplitContainer21"
import BaseModal from "../components/modals/baseModal"
import TableMain from "../components/table/TableMain"

export default {
  components: {
    SplitContainer21,
    TableMain,
    BaseModal,
    QueryButton,
    BaseContainer
  },
  data() {
    return {
      drawer: false,
      date_picker_label: "创建时间",
      date_range: "",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "quote_apply",
        title2: "table_invent",
        title3: "quote_apply_detail",
      },
      fields: _.cloneDeep(QuotationTaskController.fields.default),
      detail_fields: _.cloneDeep(QuotationTaskController.fields.detail),
      inventTable_fields: QuotationTaskController.fields.inventTable_fields,
      rules: QuotationTaskController.rules,
      QuotationTaskModel: [],
      cust_options: [],
      InclTax_Options: [
        { value: "是", label: "是" },
        { value: "否", label: "否" }
      ],
      IsHomemade_Options: [
        { value: 1, label: "是" },
        { value: 0, label: "否" },
        { value: 2, label: "纯外协" },
      ],
      qt_modal_title: "",
      QuotationTaskNum: "",//报价申请编号
      CustName: "",//客户名称
      isBusy: false,
      isBusy2: false,
      isBusy3: false,
      thisCurrent: null,
      all_role_users: [],
      emailVisible: false,
      email_subject: "",
      email_content: "",
      order_detail_his: [],
      tableHeight: 200,
      hisData: [],
      checkedConditions: [],
      onlyCheckOptions: [
        { value: 1, label: "仅待审批" },
        { value: 2, label: "仅已审批" }
      ],
      ProgressQuotationTaskNum: "",
      ProgressQuotationTaskLineNum: "",
      ProgressVisible: false,
      ProgressData: [
        // { progress_type: "success", progress_title: "报价发起", progress_status: "已完成" },
        // { progress_type: "success", progress_title: "配置物料编号和附件", progress_status: "已完成" },
        // { progress_type: "warning", progress_title: "发起采购询价申请", progress_status: "进行中" },
        // { progress_type: "info", progress_title: "采购询价中", progress_status: "" },
        // { progress_type: "info", progress_title: "采购询价完成", progress_status: "" },
        // { progress_type: "info", progress_title: "分配比例设定", progress_status: "" },
        // { progress_type: "info", progress_title: "财务成本核算", progress_status: "" },
        // { progress_type: "info", progress_title: "销售报价审批中", progress_status: "" },
        // { progress_type: "info", progress_title: "销售报价审批完成", progress_status: "" }
      ]
    }
  },
  async created() {
    const end = new Date()
    const start = this.$date.addMonths(new Date(), -1)
    this.date_range = [start, end]
    this.QuotationTaskModel = _.map(_.filter(this.fields, (m) => { return m.key != "CustName" }), (t) => {
      let m = {
        key: t.key,
        label: t.label,
        value: "",
        dataType: "input",
        require: true,
        editable: true,
        seq: 0
      }
      return m
    })
    this.QuotationTaskModel = _.orderBy(this.QuotationTaskModel, ["seq"], ["asc"])

    let _field1 = _.find(this.fields, {
      key: "fcCheckSQOHasClosed",
    })
    _field1["thStyle"].display = "true"
    let _field = _.find(this.detail_fields, {
      key: "InclTax",
    })
    _field["_options"] = {
      provider: (v) => {
        return this.InclTax_Options
      },
    }

    _field = _.find(this.detail_fields, {
      key: "IsHomemade",
    })
    _field["_options"] = {
      provider: (v) => {
        return this.IsHomemade_Options
      },
    }

    _field = _.find(this.detail_fields, {
      key: "Manufacturer",
    })
    _field["_options"] = {
      provider: (v) => {
        return _.map(this.$store.state.biz_data.baseData.CompanyInfo, (t) => {
          return { value: t.DataArea, label: t.DataArea }
        })
      },
    }
    _field = _.find(this.detail_fields, {
      key: "Currency",
    })
    _field["_options"] = {
      provider: (v) => {
        return _.map(this.$store.state.biz_data.baseData.Currency, (t) => {
          return { value: t.CurrencyCode, label: t.CurrencyCode + ":" + t.Txt }
        })
      },
    }
    _field = _.find(this.detail_fields, {
      key: "LineNum",
    })
    _field["type"] = "button"
    _field["button"] = { type: "text" }
    await this.getAllRoleUsers()
  },
  mounted() {
  },
  watch: {
    "$route": {
      handler(val) {
        if (val) {
          if (val.query.k) {
            this.QuotationTaskNum = val.query.k
            this.on_query(this.$refs.QuotationTaskTable1.SetData)
          }
        }
      },
      deep: true
      // immediate: true
    },
  },
  methods: {
    pickerOptions() {
      return {
        shortcuts: [
          {
            text: "最近7天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit("pick", [start, end])
            },
          },
          {
            text: "最近30天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit("pick", [start, end])
            },
          },
          {
            text: "最近90天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit("pick", [start, end])
            },
          },
        ],
      }
    },
    ///初始化 cust
    getBaseDataCust(v) {
      this.cust_options = _.cloneDeep(
        _.orderBy(
          this.$store.state.biz_data.userInfo.user_custs,
          ["modifiedDateTime"],
          ["desc"]
        )
      ).splice(0, 200)
      this.cust_options = _.filter(_.cloneDeep(this.cust_options), function (o) {
        if (o.Blocked == null || o.Blocked.indexOf("否") != -1) {
          return o
        }
      })
      if (v == "edit") {
        let cust_num = _.find(this.QuotationTaskModel, { key: 'CustAccount' }).value
        let _index = _.findIndex(this.cust_options, {
          AccountNum: cust_num,
        })
        if (_index < 0) {
          let _m = _.find(this.$store.state.biz_data.userInfo.user_custs, {
            AccountNum: cust_num,
          })
          this.cust_options.push(_m)
        }
      }
    },
    async getAllRoleUsers() {
      let _result = await SalesOrderController.methods.getAllRoleUserName()
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.all_role_users = _result[0]
      }
    },
    ///筛选cust
    filterMethod(v) {
      this.cust_options = _.orderBy(this.$store.state.biz_data.userInfo.user_custs, ["modifiedDateTime"], ["desc"])
      this.cust_options = _.filter(_.cloneDeep(this.cust_options), (o) => { return o.Blocked == null || o.Blocked.indexOf("否") != -1 })
      if (v) {
        this.cust_options = _.filter(this.cust_options, (t) => {
          let seiName = _.toUpper(t.SEI_Name), _v = _.toUpper(v)
          if (t.AccountNum.indexOf(v) > -1 || seiName.indexOf(_v) > -1) {
            return t
          }
        })
      }
      this.cust_options = this.cust_options.splice(0, 300)
    },

    //#region 报价申请相关操作
    async on_query(set_data, isLoading = true) {
      if (isLoading) {
        this.isBusy = true
        set_data([])
      }

      let p = { is_deleted: { "=": 0 } }
      let hasDate = true
      if (this.QuotationTaskNum && this.QuotationTaskNum != "") {
        p.QuotationTaskNum = { like: "%" + this.QuotationTaskNum + "%" }
        hasDate = false
      }
      if (this.CustName != "") {
        p.CustName = { like: "%" + this.CustName + "%" }
        hasDate = false
      }

      if (!_.isNull(this.date_range) && hasDate) {
        let _toDate = this.$date.format(this.date_range[1], "yyyy-MM-dd")
        _toDate = this.$date.format(
          this.$date.addDays(new Date(_toDate), 1),
          "yyyy-MM-dd"
        )
        p["create_at"] = { ">=": this.$date.format(this.date_range[0], "yyyy-MM-dd"), "<": _toDate }
      }

      let _result = await QuotationTaskController.methods.getData(p, "quotation_task")
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let dt = _.cloneDeep(_result[0])
        _.each(dt, (t) => {
          let _index = _.findIndex(
            this.$store.state.biz_data.userInfo.user_custs,
            { AccountNum: t.CustAccount }
          )
          if (_index > -1) {
            this.getApprover(t)
          }
        })
        // console.log(_list)
        this.hisData = dt
        this.only_methods_main(this.checkedConditions)
      }
      this.isBusy = false
    },

    getApprover(t) {
      commonController.methods.getUserNameFromRole(
        this.all_role_users,
        t,
        "fcGetSQOApprover",
        "SQOApprover",
        t.fcCheckSQOApproved
      )
    },
    only_methods_main(v) {
      let checkedValue = _.last(v)
      this.checkedConditions = [checkedValue]
      let dt = _.cloneDeep(this.hisData)
      if (checkedValue == 1) ///仅未审批
        dt = _.filter(dt, { fcCheckSQOApproved: false })
      else if (checkedValue == 2) ///仅已审批
        dt = _.filter(dt, { fcCheckSQOApproved: true })

      this.$refs.QuotationTaskTable1.SetData(_.orderBy(dt, ["id"], ["desc"]))
    },
    ///状态切换
    async state_change(data, cb) {
      if (data.selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        cb(false)
        return
      }
      if (data.state == "approved" || data.state == "unapproved") {
        let _ex = _.findIndex(data.selected_items, (t) => { return t.fcCheckSQOApproved == (data.state == "approved") })
        if (_ex > -1) {
          this.msgToasts("抱歉，已审批(待审批)数据不能再次执行审批(反审)操作！", "error")
          cb(false)
          return
        }
      }
      let ask = await this.msgModal(this.$t("notify.is_continue"))
      if (!ask) {
        cb(false)
        return
      }
      let p = {}
      if (data.state == "approved" || data.state == "unapproved") {
        let dt = _.filter(data.selected_items, (t) => { return t.fcCheckSQOApproved == !(data.state == "approved") })
        let check_ap_res = []
        ///检查是否有该权限
        let _check_ap_params = {
          list: dt,
          DocumentType: "SalesQuoteApplication",
          approve_type: "",
          isNotCheckPrivilage: data.state == "approved" ? false : true,
          action_state: data.state == "approved",
        }
        check_ap_res = await commonController.methods.checkApprovePrivilige(_check_ap_params, this)
        if (check_ap_res.notPriviligeIdList.length > 0) {
          this.msgToasts("抱歉，暂无审批编号（" + _.join(check_ap_res.notPriviligeIdList, "，") + "）的权限！", "error")
          cb(false)
          return
        }
        else if (check_ap_res.approveStatusIdList.length == 0) {
          this.msgToasts("抱歉，暂无审批人数据！", "error")
          cb(false)
          return
        }
        //检查
        if (data.state == "approved") {
          let check_rt = await QuotationTaskController.methods.checkDetailIsExists(dt)
          if (check_rt) {
            let filter_crt = _.filter(check_rt, (t) => { return t[0].IsExiste == false })
            if (filter_crt && filter_crt.length > 0) {
              this.msgToasts(_.join(_.map(filter_crt, (t) => { return t[0].QuotationTaskId }), "，") + "号申请暂无明细不能被审批！", "error")
              cb(false)
              return
            }
          }
        }
        else if (data.state == "unapproved") {
          let filter_all_distribut_approved = _.filter(data.selected_items, (t) => { return t.fcCheckSQODApprovedByTaskId == true })
          if (filter_all_distribut_approved && filter_all_distribut_approved.length > 0) {
            this.msgToasts(_.join(_.map(filter_all_distribut_approved, (t) => { return t.QuotationTaskNum }), "，") + "号申请分配已全部被审批，不能执行该操作！", "error")
            cb(false)
            return
          }
        }

        p.approved = {}
        p.approved.data = []
        p.approved.local_username = this.$global.global_data.local_username
        p.approved.approveStatusIdList = check_ap_res.approveStatusIdList
        let confirm_m = await this.$prompt('请输入审批意见', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /^[\S\s]+$/,
          inputErrorMessage: '请输入审批意见',
          inputValue: "同意"
        }).then(({ value }) => {
          return { state: true, val: value }
        }).catch(() => {
          return { state: false }
        })
        if (confirm_m && confirm_m.state) {
          p.approved.ApproveRemark = confirm_m.val
        }
        else return
      }
      else if (data.state == "deleted") {
        let is_approved = _.some(data.selected_items, ["fcCheckSQOApproved", true])
        if (is_approved) {
          this.msgToasts("已审批数据不能被删除！", "info")
          cb(false)
          return
        }
        let is_item_created_cqa = _.filter(data.selected_items, { fcCheckSQOIsCreatedCQA: true })
        if (is_item_created_cqa && is_item_created_cqa.length > 0) {
          let mbt = _.map(is_item_created_cqa, (t) => { return t.QuotationTaskNum })
          this.msgToasts(_.join(mbt, ",") + "号单据明细已创建询价申请，不能被删除！", "info")
          cb(false)
          return
        }
        let dt = _.filter(data.selected_items, (t) => { return t.fcCheckSQOApproved == false })
        p.delete = dt
      }
      else if (data.state == "copy") {
        p.copy = {}
        p.copy.data = data.selected_items.map((t) => {
          return { QuotationTaskId: t.id }
        })
      }
      let rt = await QuotationTaskController.methods.saveData(p)
      if (rt) {
        if (data.state == "deleted")
          this.$refs.QuotationTaskTable1.RemoveItems(rt[0])
        else {
          setTimeout(async () => {
            await this.on_query(this.$refs.QuotationTaskTable1.SetData, false)
          }, 150)
        }
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        cb(true)
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        cb(false)
      }
    },

    ///打印导出
    tool_invoke(data, cb) {

      if (data.tool == "adhoc_report") {
        let _data = {
          state: true,
          fields: this.fields,
          title: this.$t("table.table_customer"),
          sheet_title: "部件档案",
        }
        ///调用公用导出(如果调用特定导出则可以写在这里)
        cb(_data)
      } else {
        ///调用公用打印(如果调用特定打印则可以写在这里)
        cb(_data)
      }
    },
    ///新增、编辑
    createData() {
      this.qt_modal_title = "新建报价申请"
      _.each(this.QuotationTaskModel, (t) => {
        switch (t.key) {
          case "Price": t.value = 0; break
          case "BatchQty": t.value = 0; break
          case "quotationType": t.value = ""; break
          default: t.value = ""
        }
      })
      this.getBaseDataCust()
      this.$refs.QTModal.show()
    },
    on_cell_button_click(data) {
      this.qt_modal_title = "编辑报价申请"
      for (var k in data.item) {
        let m = _.find(this.QuotationTaskModel, { key: k })
        if (m) {
          m.value = data.item[k]
        }
      }
      this.thisCurrent = data.item
      this.$refs.QuotationTaskTable1.SetCurrentItem(data.item)
      this.getBaseDataCust("edit")
      this.$refs.QTModal.show()
    },
    async on_cell_button_click_detail(data) {
      if (data.field.key == "LineNum") {
        if (data.item.closed == 2) {
          this.msgToasts("报价已关闭，暂无相关流程数据！", "info")
          return
        }
        console.log(data.item)
        let qt_order = this.$refs.QuotationTaskTable1.GetCurrentItem()
        this.ProgressQuotationTaskNum = this.thisCurrent.QuotationTaskNum
        this.ProgressQuotationTaskLineNum = data.item.LineNum
        let _quote_type = data.item.IsHomemade == 2 ? 1 : 2
        if (qt_order.quotationType === "打样报价") _quote_type = 0
        let dt = await QuotationTaskController.methods.getQuotationProgress({
          quote_type: _quote_type,
          ItemId: data.item.ItemId,
          fcCheckSQOConsultApplayIsCreated: data.item.fcCheckSQOConsultApplayIsCreated,
          BomConfirmState: data.item.BomConfirmState,
          RouteConfirmState: data.item.RouteConfirmState,
          TransportConfirmState: data.item.TransportConfirmState,
          InventPriceConfirmState: data.item.InventPriceConfirmState,
          id: data.item.id
        })
        this.ProgressData = dt[0]
        this.ProgressVisible = true
      }
    },
    async SaveData(cb) {
      //数据验证
      let msg = "", am = {}, valid_fields = ["CustAccount", "dataAreaId", "quotationType", "ComplateDate"]
      _.each(this.QuotationTaskModel, (t) => {
        am[t.key] = t.value
        if (msg == "" && _.includes(valid_fields, t.key) && (t.value == "" || !t.value)) {
          msg = t.label + "不能为空！"
        }
      })

      if (msg != "") {
        this.msgToasts(msg, "info")
        cb(null)
        return
      }

      //调整数据
      am.ComplateDate = this.$date.format(
        new Date(am.ComplateDate),
        "yyyy-MM-dd"
      )
      let cust = _.find(this.cust_options, { AccountNum: am.CustAccount })
      if (cust) am.CustName = cust.SEI_Name
      let _create_by = am.create_by_username
      delete am.CompanyName
      delete am.create_at
      delete am.create_by_username
      delete am.fcCheckSQOApproved
      delete am.SQOApprover
      delete am.fcGetDocumentQTApproveRemark
      delete am.fcCheckSQOHasClosed
      let p = {}
      if (am.id == "") {
        delete am.id
        p.add = am
        p.documentCreateByUsername = this.$store.state.biz_data.userInfo.local_username
      }
      else {
        p.edit = am
        p.documentCreateByUsername = _create_by
      }

      let rt = await QuotationTaskController.methods.saveData(p)
      if (rt) {
        this.QuotationTaskNum = ""
        this.CustName = ""
        await this.on_query(this.$refs.QuotationTaskTable1.SetData, am.id ? false : true)
        if (this.thisCurrent != null) {
          let m = _.find(this.$refs.QuotationTaskTable1.my_data, { id: this.thisCurrent.id })
          if (m) {
            this.$refs.QuotationTaskTable1.SetCurrentItem(m)
            await this.current_changed(null, m)
          }
        }
        cb(true, true)
      }
      else {
        cb(true, false)
      }
    },

    async current_changed(old, current) {
      this.thisCurrent = current
      this.$refs.QuotationTaskTable3.SetData([])
      if (current) {
        await this.Detail_Query(current.id)
      }
    },
    async DrawerOpend() {
      let qt_order = this.$refs.QuotationTaskTable1.GetCurrentItem()
      this.$refs.QuotationTaskTable2.SetData([])
      this.$refs.QuotationTaskTable2.only_value1 = false
      this.Invent_Query(qt_order.dataAreaId)
    },
    CustChanged(custId) {
      if (!custId || custId == "") {
        return
      }
      let t = _.find(this.QuotationTaskModel, { key: 'dataAreaId' })
      let m = _.find(this.$store.state.biz_data.baseData.CompanyInfo, { CustAccountNum: custId })
      if (m) {
        t.value = m.DataArea
      }
      else {
        t.value = ""
      }
    },

    sendToEmail() {
      const range = window.getSelection().getRangeAt(0)
      const h1 = document.getElementsByName('div_email_content')
      range.setStart(h1[0], 0)
      range.setEnd(h1[0], 1)
      document.execCommand("Copy", false, "h2")
      window.open('mailto:?content-type=text/html&subject=' + this.email_subject + '&body=', "_blank")
      window.getSelection().removeAllRanges()
    },
    ///发送报价申请处理邮件
    async SendEmail(data) {
      let selected_items = this.$refs.QuotationTaskTable1.GetSelectedItems()
      ///检查
      if (selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        return
      }
      let is_all_approved = _.some(selected_items, { fcCheckSQOApproved: false })
      if (is_all_approved) {
        this.msgToasts("未审批申请单不能执行该操作！", "info")
        return
      }
      if (data.code == "add") {
        let is_ok = await this.msgModal(this.$t("notify.is_send_email"))
        if (!is_ok) return

        let p = _.map(selected_items, (t) => { return { QuotationTaskNum: t.QuotationTaskNum, IsHomemade: "" } })
        let em = await commonController.handleEmailNotify(p, "quote_apply", this, this.all_role_users, "email_get_quote_data")
        if (em) {
          this.email_subject = em.subject
          this.email_content = em.content
          let ep = { edit: _.map(selected_items, (t) => { return { id: t.id, is_send_email: true } }) }
          let rt = await QuotationTaskController.methods.saveData(ep)
          if (rt)
            _.each(selected_items, (t) => { t.is_send_email = true })
        }
      }
      this.emailVisible = true
    },

    //#endregion

    //查询物料
    async Invent_Query(dataAreaId, isPublic = false) {
      this.isBusy2 = true
      let p = {}
      // p.CustAccount = CustAccount;
      p.publicItem = 2
      if (isPublic) p.publicItem = 0
      p.dataAreaId = dataAreaId
      let _result = await InventTableController.methods.getSOInventData(p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.$refs.QuotationTaskTable2.SetData(
          _.orderBy(_result[0], ["createdDateTime"], ["desc"])
        )
      }
      this.isBusy2 = false
    },

    only_methods(isAllCust, isPublic) {
      if (this.thisCurrent) {
        this.$refs.QuotationTaskTable2.SetData([])
        this.Invent_Query(this.thisCurrent.dataAreaId, isPublic)
      }
    },

    //#region 报价明细相关
    ///查询报价明细
    async Detail_Query(QTId, isLoading = true) {
      this.order_detail_his == []
      if (isLoading)
        this.isBusy3 = true
      let p = { is_deleted: { "=": 0 } }
      p.QuotationTaskId = { "=": QTId }
      let _result = await QuotationTaskController.methods.getDetailData(p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let dt = _.each(_result[0], (t) => {
          if (t.Manufacturer != "")
            t.Manufacturer = t.Manufacturer.split(",")
        })
        this.order_detail_his = _.cloneDeep(dt)
        this.$refs.QuotationTaskTable3.SetData(_.orderBy(dt, ["LineNum"], ["asc"]))
      }
      this.isBusy3 = false
    },

    async Detail_Query_his(QTId) {
      this.order_detail_his == []
      let p = { is_deleted: { "=": 0 } }
      p.QuotationTaskId = { "=": QTId }
      let _result = await QuotationTaskController.methods.getDetailData(p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.order_detail_his = _.cloneDeep(_result[0])
      }
    },

    ///直接新增明细行
    Detail_CreateData(im) {
      let items_length = this.$refs.QuotationTaskTable3.my_data.length
      let newItems = [], m = {}
      _.each(this.detail_fields, (t) => {
        switch (t.key) {
          case 'LineNum': m[t.key] = this.$refs.QuotationTaskTable3.my_data.length + 1; break
          case 'InclTax': m[t.key] = "否"; break
          case 'IsHomemade': m[t.key] = 2; break
          default: m[t.key] = ""; break
        }
      })
      if (items_length == 0) {
        m["LineNum"] = items_length + 1
      }
      else {
        let last_m = _.last(this.$refs.QuotationTaskTable3.my_data)
        m["LineNum"] = last_m.LineNum + 1
      }
      if (im) {
        m.ItemId = im.ItemId
        m.NameAlias = im.NameAlias
      }
      let table1_current = this.$refs.QuotationTaskTable1.GetCurrentItem()
      m.id = ""
      m.QuotationTaskId = table1_current.id
      m.QuotationTaskNum = table1_current.QuotationTaskNum
      m.Manufacturer = []
      m.Manufacturer.push(table1_current.dataAreaId)
      let cust = _.find(this.$store.state.biz_data.baseData.Customer, { AccountNum: table1_current.CustAccount })
      if (cust) {
        m.InclTax = cust.InclTax
        m.Currency = cust.Currency
        m.TaxGroup = cust.TaxGroup
      }
      newItems.push(m)
      this.$refs.QuotationTaskTable3.AppendItems(newItems)
    },
    showInventView() {
      let qt_order = this.$refs.QuotationTaskTable1.GetCurrentItem()
      if (!qt_order) {
        this.msgToasts("请选择报价申请单主档！", "info")
        return
      }
      console.log(this.$refs)
      this.tableHeight = this.$refs.refSplitContainer21.$el.clientHeight - 50 - 33
      console.log(this.tableHeight)
      this.drawer = true
    },
    ///将选中物料添加到明细
    getInventIntoDetail() {
      let selected_invent_data = this.$refs.QuotationTaskTable2.GetSelectedItems()
      if (selected_invent_data.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        return
      }
      _.each(selected_invent_data, (t) => {
        this.Detail_CreateData(t)
      })
      this.drawer = false
    },
    ///明细状态切换
    async detail_state_change(data, cb) {
      if (data.selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        cb(false)
        return
      }
      let qt_order = this.$refs.QuotationTaskTable1.GetCurrentItem()
      if (data.state === "deleted") { ///删除
        if (qt_order && qt_order.fcCheckSQOApproved) {
          this.msgToasts("报价申请已审批，不能被删除！", "info")
          cb(false)
          return
        }
        let has_cqa_dt = _.filter(data.selected_items, { fcCheckSQOConsultApplayIsCreated: true })
        if (has_cqa_dt && has_cqa_dt.length > 0) {
          this.msgToasts(_.join(_.map(has_cqa_dt, (t) => { return t.LineNum }), ",") + "号数据已经创建询价申请，不能被删除！", "info")
          cb(false)
          return
        }
        let v = await this.msgModal(this.$t("notify.is_deleted"))
        if (v) {
          let db_del_dt = _.filter(data.selected_items, (t) => { return t.id != "" })
          let del_dt = _.filter(data.selected_items, (t) => { return t.id == "" })
          if (db_del_dt.length > 0) {

            let p = { delete: db_del_dt }
            let rt = await QuotationTaskController.methods.saveDetailData(p)
            if (rt) {
              this.$refs.QuotationTaskTable3.RemoveItems(db_del_dt)
              this.msgToasts(this.$t("notify.action_successfully"), "success")
              cb(false)
            }
            else {
              this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
              cb(false)
            }
          }
          this.$refs.QuotationTaskTable3.RemoveItems(del_dt)
        }
      }
      else if (data.state == "closed") { ///关闭
        if (_.findIndex(data.selected_items, (t) => t.closed == 2) > -1) {
          this.msgToasts("已关闭报价，不能再次执行该操作！", "info")
          cb(false)
          return
        }
        let v = await this.msgModal(this.$t("notify.is_continue"))
        if (v) {
          let confirm_m = await this.$prompt('请输入关闭原因', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPattern: /^[\S\s]+$/,
            inputErrorMessage: '请输入原因',
            inputValue: ""
          }).then(({ value }) => {
            return { state: true, val: value }
          }).catch(() => {
            return { state: false }
          })
          if (confirm_m && confirm_m.state) { }
          else return

          let dt = _.map(data.selected_items, (t) => {
            return {
              QuotationTaskDetailId: t.id,
              Description: confirm_m.val
            }
          })
          let _result = await QuotationTaskController.methods.addQuoteCloseApplication(dt)
          if (!_.isNull(_result) && _result && _result.length > 0) {
            let p = { edit: data.selected_items, isClosed: true }
            await QuotationTaskController.methods.saveDetailData(p)
            await this.Detail_Query(qt_order.id)
            this.msgToasts(this.$t("notify.action_successfully"), "success")
          }
          else
            this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
          cb(false)
        }
      }
    },
    ///明细行输入事件
    detail_on_input(data) {
      if (data.field.key == "Price") this.getWOTaxAmount(data.item)
    },
    ///明细行改变事件
    detail_on_change(data) {
      if (data.field.key == "InclTax") this.getWOTaxAmount(data.item)
      if (data.field.key == "Currency") this.getWOTaxAmount(data.item)

    },
    getWOTaxAmount(item) {
      let _price = item.Price
      if (item.Currency != 'CNY') {
        let m = _.find(this.$store.state.biz_data.baseData.ExchangeRate, { dispFromCurrencyCode: item.Currency })
        if (m) _price = _price * (m.ExchangeRate / 100)
      }
      item.Price_WOTax = _price
      if (item.InclTax == '是') {
        let table1_current = this.$refs.QuotationTaskTable1.GetCurrentItem()
        let tg = _.find(this.$store.state.biz_data.baseData.TaxGroupHeading, { TaxGroup: item.TaxGroup, dataAreaId: table1_current.dataAreaId })
        let _tax_value = tg.SEI_TaxValue ? tg.SEI_TaxValue : 0
        item.Price_WOTax = _.round((_price / (1 + _tax_value / 100)), 6)
      }
    },
    ///保存明细
    async Detail_SaveData(cb) {
      //数据验证
      let msg = "", p = { add: [], edit: [] }
      let detail_data = this.$refs.QuotationTaskTable3.my_data
      if (detail_data.length == 0) {
        cb(null)
        return
      }
      let mainCurrent = this.$refs.QuotationTaskTable1.GetCurrentItem()
      if (mainCurrent.fcCheckSQOApproved) {
        this.msgToasts(this.$t("notify.approved_can_not_be_edited"), "info")
        cb(null)
        return
      }
      await this.Detail_Query_his(mainCurrent.id)
      let require_fileds = _.map(_.filter(this.detail_fields, { required: true }), (t) => { return t })
      let check_repeat_dt = []
      _.each(detail_data, (t) => {
        let m = _.cloneDeep(t)
        if (!m.BatchQty)
          m.BatchQty = 0
        for (var k in m) {
          if (_.startsWith(k, "_")) delete m[k]
        }
        let cm = {}
        for (var i in this.detail_fields) {
          cm[this.detail_fields[i].key] = m[this.detail_fields[i].key]
        }
        if (m.Price_Suggest == "") m.Price_Suggest = 0
        delete cm.LineNum
        check_repeat_dt.push(cm)

        if (msg == "") {
          for (var i in require_fileds) {
            let fm = require_fileds[i]
            if ((m[fm.key] == "" || m[fm.key] == null) && (m[fm.key] != 0 && fm.key != 'BatchQty')) {
              msg = fm.label + "不能为空！"
            }
          }
          let his_detail_m = _.find(this.order_detail_his, (item) => { return item.id == m.id })
          m.FromBatchQty = (m.FromBatchQty == "" || m.FromBatchQty == null) ? 0 : m.FromBatchQty
          if (his_detail_m) {
            if (m.IsHomemade !== 0 && his_detail_m.fcCheckSQOConsultApplayIsCreated && (his_detail_m.BatchQty !== m.BatchQty || his_detail_m.FromBatchQty !== m.FromBatchQty))
              msg = m.ItemId + "号物料已产生询价申请，数量不能被变更！"
            if (his_detail_m.InventHandleBy !== null && his_detail_m.NameAlias !== m.NameAlias)
              msg = m.ItemId + "号物料已确认，物料名称不能被变更！"
          }

          if (m.BatchQty != null && m.FromBatchQty > m.BatchQty) {
            msg = "开始数量不能大于结束数量！"
          }
          else if (m.IsHomemade == 0 && m.Manufacturer.length == 0) {
            msg = "请选择制造商！"
          }
          else if (m.IsHomemade == 2) {
            m.Manufacturer = []
          }
        }

        if (m.DemandDate == "") delete m.DemandDate
        if (m.DayDemandQty == "") delete m.DayDemandQty
        if (m.FromBatchQty == "") delete m.FromBatchQty
        m.Price = parseFloat(m.Price)
        m.QuotationTaskNum = mainCurrent.QuotationTaskNum
        m.Manufacturer = _.join(m.Manufacturer, ",")
        delete m.fcCheckSQOConsultApplayIsCreated
        delete m.update_at
        delete m.update_by
        delete m.update_by_username
        delete m.create_by
        delete m.create_by_username
        if (m.id == "") {
          delete m.id
          p.add.push(m)
        }
        else {
          p.edit.push(m)
          p.documentCreateByUsername = mainCurrent.create_by_username
        }
      })
      ///检查是否有完全相同的数据行
      let no_repeat_dt = _.uniqWith(check_repeat_dt, _.isEqual)
      console.log(no_repeat_dt)
      if (no_repeat_dt.length != detail_data.length) { msg = "数据有重复项，请检查后再保存！" }
      if (msg != "") {
        this.msgToasts(msg, "info")
        cb(null)
        return
      }
      let rt = await QuotationTaskController.methods.saveDetailData(p)
      if (rt) {
        await this.Detail_Query(this.$refs.QuotationTaskTable1.GetCurrentItem().id, false)
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        cb(true, true)
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        cb(false)
      }
    },
    //复制明细行
    Detail_CopyData() {
      let detail_selected_items = this.$refs.QuotationTaskTable3.GetSelectedItems()
      if (detail_selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        return
      }
      _.each(detail_selected_items, (im) => {
        let m = _.cloneDeep(im)
        let items_length = this.$refs.QuotationTaskTable3.my_data.length
        let newItems = []
        if (items_length == 0) {
          m["LineNum"] = items_length + 1
        }
        else {
          let last_m = _.last(this.$refs.QuotationTaskTable3.my_data)
          m["LineNum"] = last_m.LineNum + 1
        }
        m.id = ""
        m.FromBatchQty = m.BatchQty + 1
        m.BatchQty = null
        newItems.push(m)
        this.$refs.QuotationTaskTable3.AppendItems(newItems)
      })
    },
    //#endregion
  },
}
</script>
<style>
.hb_table_qttable_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 128rem;
}

.hb_table_qttable_class2 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 185rem;
}

.hb_table_qttable_class3 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 75rem;
}
</style>
